import { motion } from "framer-motion";
import { Zap, Coffee, Ticket } from "lucide-react";

const STEPS = [
    {
        num: "01",
        icon: Zap,
        title: "Pre-order on the app",
        desc: "Order and pay ahead while you're still tying your shoes.",
    },
    {
        num: "02",
        icon: Coffee,
        title: "Cafe prepares your order",
        desc: "Your brew hits the express counter the moment it's ready.",
        img: "https://images.unsplash.com/photo-1551529563-fce9529e67ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxjb2ZmZWUlMjBzaG9wJTIwY291bnRlcnxlbnwwfHx8fDE3ODk5MTA2MjV8MA&ixlib=rb-4.1.0&q=85",
    },
    {
        num: "03",
        icon: Ticket,
        title: "Show Pickup Pass, grab and go",
        desc: "Flash your pass at the counter. No queue, no small talk required.",
        img: "https://images.unsplash.com/photo-1575026469075-99e9e3433e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxwZXJzb24lMjBob2xkaW5nJTIwY29mZmVlJTIwY3VwfGVufDB8fHx8MTc4OTkxMDYyNXww&ixlib=rb-4.1.0&q=85",
    },
];

export const HowItWorks = () => (
    <section id="how-it-works" className="mx-auto max-w-7xl px-6 py-20 md:py-32" data-testid="how-it-works-section">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5 }}
        >
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary">How it works</p>
            <h2 className="mt-3 max-w-lg text-3xl font-extrabold tracking-tighter sm:text-4xl lg:text-5xl">
                Three steps. <span className="text-primary">Zero queue.</span>
            </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
            {STEPS.map((step, i) => (
                <motion.article
                    key={step.num}
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.5, delay: i * 0.12 }}
                    data-testid={`how-it-works-step-${i + 1}`}
                    className="group overflow-hidden rounded-2xl border border-[#2a2a2a] bg-[#161616] transition-colors duration-200 hover:border-primary"
                >
                    {step.img ? (
                        <div className="h-40 overflow-hidden">
                            <img
                                src={step.img}
                                alt={step.title}
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                            />
                        </div>
                    ) : (
                        <div className="flex h-40 items-center justify-center bg-primary">
                            <step.icon className="h-14 w-14 text-[#111111]" strokeWidth={2.5} />
                        </div>
                    )}
                    <div className="p-7">
                        <div className="flex items-center justify-between">
                            <span className="text-5xl font-black tracking-tighter text-primary">{step.num}</span>
                            {step.img && (
                                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 text-primary">
                                    <step.icon className="h-5 w-5" strokeWidth={2.5} />
                                </span>
                            )}
                        </div>
                        <h3 className="mt-4 text-lg font-bold">{step.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-[#a1a1aa]">{step.desc}</p>
                    </div>
                </motion.article>
            ))}
        </div>
    </section>
);
